import { useController } from 'react-hook-form';
import Select, { SelectItem, SelectProps } from '../ui/Select';

interface SelectFieldProps extends SelectProps {
  control: any;
  name: string;
  label?: string;
  options: Array<{ value: string; label: string }>;
}

export default function SelectField({
  control,
  name,
  isDisabled,
  label,
  options,
  ...rest
}: SelectFieldProps) {
  const {
    field,
    fieldState: { error, invalid },
    formState: { isSubmitting },
  } = useController({
    name,
    control,
  });

  return (
    <Select
      onBlur={field.onBlur}
      name={field.name}
      errorMessage={error?.message}
      label={label}
      isDisabled={isDisabled}
      isReadOnly={isSubmitting}
      isInvalid={invalid}
      selectedKey={field.value}
      validationBehavior="aria"
      onSelectionChange={(newValue) => {
        const selectedOption = options.find((option) => option.value === newValue);

        field.onChange(selectedOption?.value);
      }}
      {...rest}
    >
      {options.map((option) => (
        <SelectItem key={option.value} id={option.value}>
          {option.label}
        </SelectItem>
      ))}
    </Select>
  );
}
